/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { InvitationResponse } from '../../models/invitation-response';

export interface InvitationControllerFindOne$Params {
  identifier: string;
}

export function invitationControllerFindOne(http: HttpClient, rootUrl: string, params: InvitationControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, invitationControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('identifier', params.identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: InvitationResponse;
      }>;
    })
  );
}

invitationControllerFindOne.PATH = '/invitation/{identifier}';
